import React from "react";

const PLANS = ["Founding Monthly", "Quarterly Companion", "Yearly Companion"];
const ROWS = [
  ["Price", "$9.99 / month", "$29.99 / 3 months", "$89.99 / year"],
  ["Effective monthly", "$9.99", "$9.99", "$7.50"],
  ["Workbook access", "All 7 chapters while active", "All 7 chapters while active", "All 7 chapters all year"],
  ["Mirror reflections", "Unlimited", "Unlimited", "Unlimited · priority"],
  ["Narrator voice & Whisper transcription", "Included", "Included", "Included"],
  ["Ebooks from the library", "3 per month", "3 per quarter", "12 per year"],
  ["Printed chapter books", "—", "Break-even pricing", "One free printed book"],
  ["Price lock & cancel", "$9.99 locked through Dec 31, 2027 · cancel anytime", "Cancel at the end of any quarter", "Cancel any renewal"],
];

export default function PlanComparison() {
  return (
    <section className="mt-16 sm:mt-20 max-w-6xl" data-testid="pricing-comparison">
      <p className="font-sans uppercase tracking-[0.28em] text-xs text-terracotta mb-3">Compare plans</p>
      <h2 className="font-serif text-2xl sm:text-3xl text-bone-100 mb-6">What changes at each price.</h2>
      <ul className="sm:hidden space-y-4" data-testid="pricing-comparison-mobile">
        {ROWS.map(([label, ...cells]) => (
          <li key={label} className="border-t border-obsidian-600 pt-3">
            <p className="font-sans text-xs uppercase tracking-[0.18em] text-bone-500 mb-2">{label}</p>
            <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 font-sans text-sm">
              {cells.map((c, i) => (
                <React.Fragment key={i}>
                  <dt className={i === 2 ? "text-terracotta" : "text-bone-400"}>{PLANS[i].split(" ")[0]}</dt>
                  <dd className="text-bone-200">{c}</dd>
                </React.Fragment>
              ))}
            </dl>
          </li>
        ))}
      </ul>
      <div className="hidden sm:block overflow-x-auto border border-obsidian-600">
        <table className="w-full min-w-[560px] text-left font-sans text-sm" data-testid="pricing-comparison-table">
          <thead>
            <tr className="border-b border-obsidian-600 bg-obsidian-800/60">
              <th scope="col" className="p-3 sm:p-4 font-normal text-bone-500 text-xs uppercase tracking-[0.18em] w-[28%]">Feature</th>
              {PLANS.map((p, i) => (
                <th key={p} scope="col" className={`p-3 sm:p-4 font-serif text-base font-normal ${i === 2 ? "text-terracotta bg-terracotta/[0.06]" : "text-bone-100"}`}>
                  {p}{i === 2 && <span className="block font-sans text-[0.6rem] uppercase tracking-[0.24em] mt-1">Recommended</span>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([label, ...cells], r) => (
              <tr key={label} className="border-b border-obsidian-700 last:border-0" data-testid={`pricing-comparison-row-${r}`}>
                <th scope="row" className="p-3 sm:p-4 font-normal text-bone-400 align-top">{label}</th>
                {cells.map((c, i) => (
                  <td key={i} className={`p-3 sm:p-4 align-top text-bone-200 ${i === 2 ? "bg-terracotta/[0.06]" : ""}`}>{c}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
